import { render, staticRenderFns } from "./orderPrintProcess.vue?vue&type=template&id=22ce1fcb&scoped=true"
import script from "./orderPrintProcess.vue?vue&type=script&lang=js"
export * from "./orderPrintProcess.vue?vue&type=script&lang=js"
import style0 from "./orderPrintProcess.vue?vue&type=style&index=0&id=22ce1fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ce1fcb",
  null
  
)

export default component.exports